import { useId } from 'react'
import { kFormatter, type Unit } from '~/util/format'

type ColorPair = [number, string]

type InterpolatedProps = {
  pairs: ColorPair[]
  unit?: Unit
}

export function Interpolated({ pairs, unit }: InterpolatedProps) {
  const gradientId = useId()

  return (
    <div className="max-w-[200px]">
      <svg width="100%" height="100%">
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
          {pairs.map(([value, color], i: number) => (
            <stop key={value} offset={`${(i * 100) / (pairs.length - 1)}%`} stopColor={color} />
          ))}
        </linearGradient>
        <rect x="5%" y="5%" rx="15" ry="15" width="30%" height="90%" fill={`url(#${gradientId})`} />
        {pairs.map(([value], i: number) => {
          const [formattedValue, suffix] = kFormatter(value, unit)
          return (
            <text
              key={value}
              x="50%"
              y={`${15 + (i * 70) / (pairs.length - 1)}%`}
              fill="#66717C"
              dominantBaseline="middle"
            >
              {formattedValue}
              {suffix}
            </text>
          )
        })}
      </svg>
    </div>
  )
}
